import { EditableGrid, EditorField } from "@/components/common/EditableGrid";
import { ShowAccordionSection } from "@/components/common/ShowAccordionSection";
import { Policy, ResourceName } from "@/types";
import { formatYearRange } from "@/utils/formatters/dateFormatter";

/** Build a consistent policy label from a policy record */
const getPolicyLabel = (policy: Policy): string => {
  const carrierName = policy.vendor_company_name || "No Carrier";
  const year = formatYearRange(policy.effective_start_date, policy.effective_end_date);
  return year ? `${carrierName} ${year}` : carrierName;
};

export const ClaimItemOverview = () => {
  const summaryFields: EditorField[] = [
    {
      type: "reference",
      source: "claimant_id_ref",
      reference: ResourceName.CLAIMANTS,
      displayField: "claimant_name",
      label: "Claimant Name",
      readOnlyReason: "Use the Reassign action to change",
    },
    {
      type: "reference",
      source: "client_id_ref",
      reference: ResourceName.CLIENTS,
      displayField: "client_legal_name",
      label: "Client Name",
      readOnlyReason: "Use the Reassign action to change",
    },
    {
      type: "reference",
      source: "policy_id_ref",
      reference: ResourceName.POLICIES,
      displayField: "vendor_company_name",
      label: "Policy",
      getOptionLabel: (option: Policy) => getPolicyLabel(option),
      readOnlyReason: "Use the Reassign action to change",
    },
    {
      source: "provider",
      label: "Provider",
    },
    {
      source: "source_claim_id",
      label: "Source Claim ID",
    },
  ];

  return (
    <ShowAccordionSection label="Overview" defaultExpanded>
      <EditableGrid fields={summaryFields} recordType={ResourceName.CLAIM_ITEMS} />
    </ShowAccordionSection>
  );
};
